




































import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import ModalDialog from 'components/modals/Dialog.vue'
import MeUpdate from 'src/graphql/person/MeUpdate.gql'
import api from 'src/assets/api/gql'
import { PersonMenu } from 'src/graphql/types'

@Component({
  components: {
    ModalDialog
  }
})
export default class AccountMenuChange extends Vue {
  PersonMenu = PersonMenu
  state = store.state
  person = store.state.person
  loading: boolean = false
  error: boolean = false

  @Ref()
  readonly dialog!: ModalDialog

  get name (): string {
    return this.$t('account.menu.'+this.person.profileMenu).toString()
  }

  async change (profileMenu: PersonMenu) {
    this.dialog.hide()
    this.loading = true
    const { data: { updatePerson } } = await api.mutate({
      query: MeUpdate,
      variables: { id: this.person.id, data: { profileMenu } }
    })
    this.loading = false
    if (updatePerson && updatePerson.person) {
      store.setPerson(updatePerson.person)
    }
  }
}
